import { makeAutoObservable } from "mobx";
import { createMutations } from "./mutations";
import { initialState } from "./state";
import landingPageReportActions from "./actions";

const landingPageReportStore = () => {
  const store = {
    ...initialState,
    ...landingPageReportActions
  };

  const mutations = createMutations(store);
  Object.assign(store, mutations);
  
  makeAutoObservable(store);
  return store;
};

export default landingPageReportStore();